module.exports = __webpack_public_path__ + "img/portfolio_snapshot2.62b46912.png";